import Constants from './constants';
import { UserActionTypes } from './actions';
import AppConfig from '../../config/AppConfig';
import { siDocsBannerDisabledByUser, siDocsBannerNotExpired } from '../../utils/utils';

const userFromServer = window.___INITIAL_STATE__.user || {};
const orgFromServer = window.___INITIAL_STATE__.organization || {};

const initialState = {
  firstName: userFromServer.first_name || '',
  lastName: userFromServer.last_name || '',
  isPro: userFromServer.is_pro || false,
  isAdmin: userFromServer.is_admin || false,
  isDemo: userFromServer.is_demo || false,
  subscriptionEndDate: userFromServer.subscription_end_date || null,
  shouldDisplayRenewalBanner: userFromServer.should_display_renewal_banner || false,
  shouldDisplayRenewalWithChangedPriceBanner: userFromServer.should_display_renewal_banner_changed_pricing || false,
  shouldDisplayTrialUpsellBanner: userFromServer.should_display_trial_upsell_banner || false,
  shouldDisplayPasswordExpireBanner: userFromServer.should_display_password_expire_banner || false,
  shouldDisplaySiDocsBanner: AppConfig.SI_DOCS_BANNER_ENABLED && !siDocsBannerDisabledByUser && siDocsBannerNotExpired,
  isMigrationOrg: orgFromServer.is_migration_org || false,
  activeDiscounts: orgFromServer.active_discounts || [],
  isActiveOrg: orgFromServer.is_active || false,
  orgId: userFromServer.organization || null,
  orgName: userFromServer.organization_name || null,
  userId: userFromServer.user_id || null,
  subscription: null,
  proBalance: userFromServer.pro_balance || -2,
  email: userFromServer.email || '',
  username: userFromServer.username || '',
  isPastTrial: userFromServer.is_past_trial || false,
  isPastPaid: userFromServer.is_past_paid || false,
  isActive: userFromServer.is_active || false,
  passwordExpiration: userFromServer.password_expiration || null,
};

const HANDLER = {
  [UserActionTypes.CLOSED_PASSWORD_BANNER]: state => {
    return {
      ...state,
      shouldDisplayPasswordExpireBanner: false,
    };
  },
};

/**
 * @param  {initialState} state
 * @param  {{type: string, payload: Object}} action
 */
export function userReducer(state = initialState, action) {
  if (HANDLER[action.type]) {
    return HANDLER[action.type](state, action);
  }

  return state;
}

export default {
  reducer: userReducer,
  name: Constants.MODULE_NAME,
};
